module.exports = __webpack_public_path__ + "static/media/payment-posting.76e70b08.svg";